import { Outlet, useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ContentLayout, LoadingScreen } from '@nohara-dxdev/react-core';
import {
  UserOnboardingCheck,
  OrgSelectCheck,
  useApp,
  AppendScopeItem,
} from '@nohara-dxdev/react-oidc';

import { AppLayout } from '@/components/layouts';
import { paths } from '@/config/paths';
import { env } from '@/config/env';

import NotFoundRoute from '../not-found';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error(error);

  return (
    <AppLayout>
      <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>
    </AppLayout>
  );
};

const OrgRoot = () => {
  const { data: app, isLoading } = useApp(env.APP_ID);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <AppendScopeItem type='app' id={env.APP_ID} entity={app}>
      <UserOnboardingCheck onboardingPath={paths.onboarding.getHref()}>
        <OrgSelectCheck
          getOrgPath={paths.org.dashboard.getHref}
          Layout={AppLayout}
          fallbackElement={<NotFoundRoute />}
          ignorePaths={[paths.onboarding.getHref()]}
        >
          <Outlet />
        </OrgSelectCheck>
      </UserOnboardingCheck>
    </AppendScopeItem>
  );
};

export default OrgRoot;
